import { memo } from 'motion-utils';

const supportsScrollTimeline = /* @__PURE__ */ memo(() => window.ScrollTimeline !== undefined);

export { supportsScrollTimeline };
//# sourceMappingURL=scroll-timeline.mjs.map
